import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	edit: { force: false, sn_list: '' },
	isLoaded: true,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// ****************** FETCH SOFTWARE DETAIL ******************
			case types.FETCH_SOFTWARE_DETAIL_LOADING:
				draft.isLoaded = false;
				draft.error = false;
				draft.edit = {};
				break;

			case types.FETCH_SOFTWARE_DETAIL_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				break;

			case types.FETCH_SOFTWARE_DETAIL_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				break;

			default:
				return state;
		}
	});
